import axios from "axios";

/*
 * Backend URL resolver — robust against env-var mismatches between preview & prod.
 *
 * Rule:
 *  - If REACT_APP_BACKEND_URL is set AND its origin matches window.location.origin → use it.
 *  - Otherwise (production deploys where the env-var still points to preview,
 *    or env-var missing) → fall back to same-origin (`window.location.origin`),
 *    which works on Emergent because `/api/*` is reverse-proxied to the backend
 *    by the platform ingress.
 *
 * This keeps preview behaviour identical while preventing the "Network Error"
 * cross-origin failure on hub.ieftinit.ro and similar production domains.
 */
function resolveBackendOrigin() {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return env || "";
  const currentOrigin = window.location.origin;
  if (env) {
    try {
      const u = new URL(env);
      if (u.origin === currentOrigin) return env.replace(/\/$/, "");
    } catch {}
  }
  return currentOrigin;
}

const BACKEND_URL = resolveBackendOrigin();
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "ieftinit_token";

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setToken(t) {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch {}
}

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

/* Export helper for non-axios usage (links, download URLs, raw fetch). */
export function backendOrigin() {
  return BACKEND_URL;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "A apărut o eroare neașteptată.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
